// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".question__title[data-v-9d9e55c6]{display:flex;justify-content:space-between;cursor:pointer}.question__title-text[data-v-9d9e55c6]{font-weight:700;font-size:16px;color:#ffffff}.question__title-text-opened[data-v-9d9e55c6]{color:#a69eff}.question__title-icon[data-v-9d9e55c6]{width:16px;height:16px;flex-shrink:0;margin-left:8px;display:flex;align-items:center;margin-top:4px}.question__text[data-v-9d9e55c6]{margin-top:8px}\n", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
